export interface labelProviderInterface {
    (name: string, fallback: string): string
}

export const defaultLabelProvider: labelProviderInterface = (name: string, fallback: string) => {
    return fallback;
};
